<template>
    <div class="transaction-main">
        <div class="main">
            <div class="filter-box">
                <p class="fl label">订单编号</p>
                <input class="fl input-box" placeholder="请输入订单编号"/>
                <p class="fl label">发票类型</p>
                <select class="input-box fl ">
                    <option value="">增值税专用发票</option>
                    <option value="">增值税普通发票</option>
                </select>
                <p class="fl label">申请时间</p>
                <el-date-picker class="fl "
                                v-model="date"
                                type="date"
                                size="small"
                                placeholder="选择日期">
                </el-date-picker>

                <button class="filter-button resetting fr">重置</button>
                <button class="filter-button search fr">查询</button>
                <div class="clear"></div>
            </div>
            <div class="main-body">
                <el-table
                        :data="tableData"
                        :default-sort="{ prop: 'date', order: 'descending' }"
                        stripe
                        style="width: 97%"
                        class="body-table"
                        :row-style="{ height: '46px' }"
                        :header-cell-style="{ textAlign: 'center' }"
                        :cell-style="{ textAlign: 'center' }"
                >
                    <el-table-column prop="type" label="发票类型"></el-table-column>
                    <el-table-column prop="headType" label="抬头类型"></el-table-column>
                    <el-table-column prop="name" label="申请人"></el-table-column>
                    <el-table-column prop="date" label="申请时间"></el-table-column>
                    <el-table-column prop="status" label="订单状态"></el-table-column>
                    <el-table-column prop="edit" label="操作">
                        <a @click="showDetail" class="refund pointer">查看</a>
                    </el-table-column>
                </el-table>
            </div>
            <div class="main-bottom">
                <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total"
                        class="fenye"
                        @current-change="current_change"
                >
                </el-pagination>
            </div>
        </div>
        <el-dialog
                title="代开发票"
                :visible.sync="dialogVisible"
                width="600px"
        >
            <div class="text-box relative">
                <img class="icon" src="@/assets/shop/bill-over-icon.png" alt="">
                <div class="line-text">
                    <div class="text fl">
                        <p class="fl label-text">发票类型</p>
                        <p class="fl content">增值税专用发票</p>
                    </div>
                    <div class="text fr">
                        <p class="fl label-text">发票抬头</p>
                        <p class="fl content">个人</p>
                    </div>
                </div>
                <div class="line-text">
                    <div class="text fl">
                        <p class="fl label-text">个人名称</p>
                        <p class="fl content">张琳琳</p>
                    </div>
                </div>
                <div class="clear"></div>
                <div class="more-line">
                    <span class="text">收票人信息（该信息可与收货人信息不同）</span>
                </div>
                <div class="line-text">
                    <div class="text fl">
                        <p class="fl label-text">收票人姓名</p>
                        <p class="fl content">林娇娇</p>
                    </div>
                    <div class="text fr">
                        <p class="fl label-text">收票人手机</p>
                        <p class="fl content">12588796653</p>
                    </div>
                    <div class="clear"></div>
                </div>
                <div class="line-text">
                    <div class="text fl">
                        <p class="fl label-text">所在地区</p>
                        <p class="fl content">廊坊市广阳区经济技术开发区润泽道</p>
                    </div>
                    <div class="text fr">
                        <p class="fl label-text">详细地址</p>
                        <p class="fl content">廊坊市广阳区经济技术开发区润泽道</p>
                    </div>
                    <div class="clear"></div>
                </div>
                <div class="more-line">
                    <span class="text">发票内容（商品明细）</span>
                </div>
            </div>
            <div class="good-info-box">
                <div class="flex-box line title border-bottom">
                    <p class="flex-1 name">商品名称</p>
                    <p class="price text-center">价格</p>
                    <p class="count text-center">数量</p>
                </div>
                <ul class="good-list">
                    <li class="flex-box line border-bottom" v-for="item in goodList" :key="item">
                        <p class="flex-1 name">晨光文具签字笔荧光多种彩色</p>
                        <p class="price text-center red">¥2.5</p>
                        <p class="count text-center">x1</p>
                    </li>
                </ul>
                <div class="flex-box line title border-bottom strong">
                    <p class="flex-1 name">商品合计</p>
                    <p class="total text-center red">￥10</p>
                </div>
                <div class="flex-box line title  strong">
                    <p class="flex-1 name">订单编号</p>
                    <p class="order-num text-center">125559866593</p>
                </div>
            </div>
        </el-dialog>

    </div>
</template>

<script>
  export default {
    name: "transactionManage",
    data() {
      return {
        date: '',
        dialogVisible: false,
        tableData: [
          {
            type: "增值税专用发票",
            headType: '单位',
            name: "张三",
            date: "2019-11-04 07:30",
            status: '已完成'
          },
          {
            type: "增值税专用发票",
            headType: '单位',
            name: "张三",
            date: "2019-11-04 07:30",
            status: '已完成'
          }
        ],
        total: 10,
        goodList:[1,2,3,4],
        pagesize: 8, //每页的数据条数
        currentPage: 1, //默认开始页面
        istag: true,
      };
    },
    created: function () {
      this.total = this.tableData.length;
    },
    methods: {
      search() {
        this.getOrderList()
      },
      reset() {
        this.currentPage = 1;
        this.orderNum = '';
        this.startTime = '';
        this.endTime = '';
        this.getOrderList()
      },

      showDetail(){
        this.dialogVisible = true;
      },
      current_change: function (currentPage) {
        this.currentPage = currentPage;
      }
    },

  };
</script>

<style scoped lang="scss">
    @import "~@/css/order.scss";
    @import "~@/css/bill_dialogs.scss";
    .relative{
        position: relative;
    }
    .icon{
        position: absolute;
        height: 110px;
        width: 110px;
        right: 15px;
        top: -5px;
    }
</style>
